import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import "./HomeWorkContent.scss";
import HomeWorkList from "./homework_data/HomeWorkList";
import SortPopover from "./homework_data/popover/SortPopover";
import { url_83, url_258 } from "../../../../custom_utilities/api_services";
import DateRangePicker from "../../user_refer_earn/ReferAndEarnModals/DateRangePicker";
import { goBackFromPracticePage } from "../../../../custom_utilities/dashboardBannerNavigation";
import images from "../../../../utilities/images/images";

const HomeWorkContent = ({ userPreference, token, tokenType, showBackArrow }) => {
  const history = useHistory();
  const location = useLocation();
  const [subject, setSubject] = useState({});
  const [subjectsList, setSubjectsList] = useState([]);
  const [inputValue, setInputValue] = useState(""); // Sorting value
  const [homeworkData, setHomeworkData] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [subjectsLoading, setSubjectsLoading] = useState(true);
  const [listLoading, setListLoading] = useState(true);
  const subjectsRef = useRef(null);
  const listRequestRef = useRef(0);

  useEffect(() => {
    getSubjectList();
  }, []);

  useEffect(() => {
    if (subject?.sub_id) {
      getHomeWorkList(subject.sub_id, startDate, endDate);
    }
  }, [inputValue, subject]);

  const getSubjectList = async () => {
    const headers = {
      Authorization: `${tokenType} ${token}`,
    };

    let { courseDetails, classDetails } = userPreference;
    let data = {
      course_id: courseDetails[0].course_id,
      class_id: classDetails.class_id,
    };

    setSubjectsLoading(true);
    try {
      const response = await axios.post(url_83, data, { headers });

      if (response.status === 200) {
        setSubjectsList(response.data.data.subject);
        setSubject(response.data.data.subject[0]); // Set the first subject initially
      } else {
        setListLoading(false);
      }
    } catch (err) {
      console.error("Error fetching subjects:", err);
      setListLoading(false);
    } finally {
      setSubjectsLoading(false);
    }
  };

  const getHomeWorkList = async (subjectId, fromDate, toDate) => {
    const headers = {
      Authorization: `${tokenType} ${token}`,
    };

    let params = new URLSearchParams({
      subject_id: subjectId,
      sort_by:
        inputValue === "newest"
          ? "NEW"
          : inputValue === "oldest"
          ? "OLD"
          : inputValue === "unattempted"
          ? "Unattempted"
          : "",
    });

    if (fromDate && toDate) {
      params.append("from_date", fromDate);
      params.append("to_date", toDate);
    }

    const requestId = ++listRequestRef.current;
    setListLoading(true);

    try {
      const response = await axios.get(`${url_258}?${params.toString()}`, {
        headers,
      });
      if (requestId !== listRequestRef.current) return;
      if (response.status === 200) {
        setHomeworkData(response.data.data);
      }
    } catch (err) {
      if (requestId !== listRequestRef.current) return;
      console.error("Error fetching homework:", err);
    } finally {
      if (requestId === listRequestRef.current) {
        setListLoading(false);
      }
    }
  };

  const scrollSubjects = (direction) => {
    if (subjectsRef.current) {
      const subjectWidth = 300;
      subjectsRef.current.scrollLeft +=
        direction === "left" ? -subjectWidth : subjectWidth;
    }
  };

  return (
    <div className="homework_container">
      <div className="homework_header_row">
        {showBackArrow ? (
          <button
            type="button"
            className="homework-back-btn"
            onClick={() => goBackFromPracticePage(history, location)}
            aria-label="Back to Practice"
          >
            <img src={images.new_backarrow} alt="" />
          </button>
        ) : null}
        <div className="homework_header">Homework</div>
      </div>

      <div className="homework_subjects_wrapper">
        {subjectsLoading ? (
          <div className="homework_subjects homework_skeleton_subjects" aria-hidden="true">
            {[0, 1, 2].map((item) => (
              <div key={item} className="hw-skeleton hw-skeleton-subject" />
            ))}
          </div>
        ) : (
          <>
            <button className="arrow left" onClick={() => scrollSubjects("left")}>
              &#10094;
            </button>

            <div className="homework_subjects" ref={subjectsRef}>
              {subjectsList.map((sub) => (
                <div
                  key={sub.sub_id}
                  onClick={() => setSubject(sub)}
                  className={`single_subject ${
                    subject.sub_name === sub.sub_name ? "selected_sub" : ""
                  }`}
                >
                  <div className="sub_icon">
                    <img src={sub.icon1} alt="icon" />
                  </div>
                  <div className="sub_name">{sub.sub_name}</div>
                </div>
              ))}
            </div>

            <button className="arrow right" onClick={() => scrollSubjects("right")}>
              &#10095;
            </button>
          </>
        )}
      </div>

      {subjectsLoading ? (
        <div className="homework_filters homework_skeleton_filters" aria-hidden="true">
          <div className="hw-skeleton hw-skeleton-filter" />
          <div className="hw-skeleton hw-skeleton-filter hw-skeleton-filter--short" />
        </div>
      ) : (
        <div className="homework_filters">
          Custom Date
          <DateRangePicker
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            onConfirm={(fromDate, toDate) =>
              getHomeWorkList(subject.sub_id, fromDate, toDate)
            }
          />
          <div className="filter_by_sort_options">
            <SortPopover inputValue={inputValue} setInputValue={setInputValue} />
          </div>
        </div>
      )}
      <div className="homework_content" aria-busy={listLoading}>
        {listLoading ? (
          <div className="homework_list_container" aria-hidden="true">
            {[0, 1, 2, 3].map((item) => (
              <div key={item} className="homework_item_container hw-skeleton-card">
                <div className="hw-skeleton hw-skeleton-line hw-skeleton-line--short" />
                <div className="hw-skeleton hw-skeleton-line" />
                <div className="hw-skeleton hw-skeleton-line hw-skeleton-line--medium" />
                <div className="hw-skeleton-card-footer">
                  <div className="hw-skeleton hw-skeleton-chip" />
                  <div className="hw-skeleton hw-skeleton-button" />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <HomeWorkList homeworkData={homeworkData} />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  token: state.auth.authToken,
  tokenType: state.auth.tokenType,
  userPreference: state.userPreference,
});

export default connect(mapStateToProps, null)(HomeWorkContent);
